var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircle2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M16.014 17.138H9.027v-1.47l2.51-2.536q.757-.78 1.216-1.299.465-.526.67-.957.212-.43.212-.923 0-.594-.335-.889-.328-.3-.882-.3-.58 0-1.128.266-.546.266-1.142.76L9 8.428q.43-.37.91-.698a4.2 4.2 0 0 1 1.12-.526Q11.673 7 12.568 7q.986 0 1.689.355.71.356 1.094.971.382.609.382 1.381 0 .827-.328 1.51a5.4 5.4 0 0 1-.957 1.354q-.622.67-1.504 1.484l-1.285 1.21v.095h4.355z"
})));
export default SvgCircle2;